module.exports = __webpack_public_path__ + "static/media/home5.7a69b22e.jpg";